import { createContext, useContext, useEffect } from 'react';
export type DraftState = { dirty: boolean; busy: boolean };
export const ProfileDrafts = createContext<(key: string, state: DraftState) => void>(() => {});
export function useProfileDraft(key: string, dirty: boolean, busy = false) {
  const report = useContext(ProfileDrafts);
  useEffect(() => {
    report(key, { dirty, busy });
    return () => report(key, { dirty: false, busy: false });
  }, [report, key, dirty, busy]);
}
